import { render, staticRenderFns } from "./Ips.vue?vue&type=template&id=18f8d08e&scoped=true"
import script from "./Ips.vue?vue&type=script&lang=js"
export * from "./Ips.vue?vue&type=script&lang=js"
import style0 from "./Ips.vue?vue&type=style&index=0&id=18f8d08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f8d08e",
  null
  
)

export default component.exports